export const DayNames = {
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday'
};

export const TableHeaders = {
  DAY_OF_WEEK: 'Day of the Week',
  HOURS: 'Hours'
};